import { RootState } from '../../../../rootReducer';

export const productSelector = (state: RootState) => state.handbookModuleReducer.ProductReducer;
